/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetails } from './InstanceBulkDecisionRequestBidirectionalActionDetails';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsToJSONTyped,
} from './InstanceBulkDecisionRequestBidirectionalActionDetails';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequest
 */
export interface InstanceBulkDecisionRequest {
    /**
     * 
     */
    lead_ids: Array<string>;
    /**
     * 
     */
    status_id: string;
    /**
     * 
     */
    bidirectional_action_details?: InstanceBulkDecisionRequestBidirectionalActionDetails;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequest interface.
 */
export function instanceOfInstanceBulkDecisionRequest(value: object): value is InstanceBulkDecisionRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    if (!('status_id' in value) || value['status_id'] === undefined) return false;
    return true;
}

export function InstanceBulkDecisionRequestFromJSON(json: any): InstanceBulkDecisionRequest {
    return InstanceBulkDecisionRequestFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'status_id': json['status_id'],
        'bidirectional_action_details': json['bidirectional_action_details'] == null ? undefined : InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON(json['bidirectional_action_details']),
    };
}

export function InstanceBulkDecisionRequestToJSON(json: any): InstanceBulkDecisionRequest {
    return InstanceBulkDecisionRequestToJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestToJSONTyped(value?: InstanceBulkDecisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
        'status_id': value['status_id'],
        'bidirectional_action_details': InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON(value['bidirectional_action_details']),
    };
}

